import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';

/**
 * Generated class for the PoinotePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-poinote',
  templateUrl: 'poinote.html',
})
export class PoinotePage {

  note = ''
  forpoi = ''
  prednotes = []
  driverorg = 0
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
  }

  ionViewDidLoad() {
    this.forpoi = this.navParams.get('obj').name;
    this.note = this.navParams.get('obj').note;
    this.loadEmployeeorg()
  }

  loadPredefinedNotes() {
    var _that = this
    this.gn._Post('/api/gn/getPredNotes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      for (let i = 0; i < _data.length; i++) {
        console.log(_data[i].employeeid, '_data[i].employeeid')
        console.log(_that.gn.user.driverid, '_that.gn.user.driverid')
        if (_data[i].employeeid == _that.gn.user.driverid || (_data[i].orgid == null && _data[i].employeeid == null) || (_that.driverorg == _data[i].orgid && _data[i].employeeid == null)) {
          _that.prednotes.push(_data[i])
        }
      }
      // _that.prednotes = _data
    })
  }

  loadEmployeeorg() {
    var _that = this
    this.gn._Post('/api/gn/getDriverOrg', { uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.driverorg = _data[0].organisationid
      console.log(_that.driverorg, '_that.driverorg')
      _that.loadPredefinedNotes()
      // for (let i = 0; i < _data.length; i++) {
      //   if (_data[i].employeeid == _that.gn.user.UserId || (_data[i].orgid == null && _data[i].employeeid == null) || (_that.gn.user.UserGroup == _data[i].orgid && _data[i].employeeid == null)) {
      //     _that.prednotes.push(_data[i])
      //   }

      // }
      // _that.prednotes = _data
    })

  }

  insertPoiNote() {
    var cb = this.navParams.get('cb')
    var obj = this.navParams.get('obj')
    var hederid = this.navParams.get('hederid')

    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId),
      hederid: this.gn.crypt(hederid),
      note: this.gn.crypt(this.note),
      noteid: this.gn.crypt(this.navParams.get('obj').noteid),
      poiid: this.gn.crypt(obj.id),
      rbr: this.gn.crypt(obj.idx),
      visited: this.gn.crypt(obj.visited),
      insertnote: this.gn.crypt(1),
    }

    var _that = this
    this.gn._Post('/api/insertPoiNote', _dat, function (_data) {
      cb(_that.note, _data.noteid);
      _that.navCtrl.pop()
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/poinote/poinote.ts